import type { ComponentProps, FC } from "react";

import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

/** Ghost 28px icon button with a bottom tooltip; the tab bar's only button style. */
export const HeaderIconButton: FC<
  ComponentProps<typeof Button> & { label: string; pressed?: boolean }
> = ({ label, pressed, className, ...props }) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <Button
        variant="ghost"
        size="icon"
        aria-label={label}
        aria-pressed={pressed}
        className={cn(
          "size-7 text-fg-3 hover:text-fg disabled:opacity-40",
          pressed === false && "text-fg-4",
          className
        )}
        {...props}
      />
    </TooltipTrigger>
    <TooltipContent side="bottom">{label}</TooltipContent>
  </Tooltip>
);

/** Space between header control groups; toolbars separate groups with gaps, not rules. */
export const HeaderDivider: FC<{ className?: string }> = ({ className }) => (
  <div className={cn("w-1.5 shrink-0", className)} aria-hidden />
);
